import React, { useEffect } from "react";
import { Container, Spinner } from "react-bootstrap";
import TeamTile from "./TeamTile";
import { useData } from "../../providers/dataProvider";
import "./MeetTheTeam.css";
import { pageMeta } from "../../config/helmetConfig";
import { updateMetaTags } from "../../utils/metaManager";

export default function MeetTheTeam() {
  const { teamMembers, teamMembersLoading } = useData();
  const sortedTeamMembers = [...teamMembers].sort(
    (a, b) => (a.display_order || 999) - (b.display_order || 999)
  );

  useEffect(() => {
    updateMetaTags(pageMeta.team);
  }, []);

  if (teamMembersLoading) {
    return (
      <div className="team-page-container">
        <div className="team-brick-background"></div>
        <div className="team-content-section">
          <div className="team-header-section">
            <Container fluid className="px-3">
              <h1 className="team-title">Meet the Team</h1>
              <div className="team-loading-card">
                <Spinner animation="border" />
                <p>Loading team members...</p>
              </div>
            </Container>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="team-page-container">
      <div className="team-brick-background"></div>

      <div className="team-content-section">
        <div className="team-header-section">
          <Container fluid className="px-3">
            <h1 className="team-title">Meet the Team</h1>
          </Container>
        </div>

        <div className="team-members-section">
          <div className="team-members-container">
            {sortedTeamMembers.length > 0 ? (
              sortedTeamMembers.map((member, index) => (
                <TeamTile
                  key={member.id || index}
                  member={member}
                  reversed={index % 2 === 0}
                />
              ))
            ) : (
              <div className="no-team-members">
                <p>No team members found.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
